import API from './api';

// Fire-and-forget client-side activity tracking → POST /api/activity.
// Stored forever in the UserActivity event store for personalization/ML.
// Never throws; failures are silently ignored.
const recordActivity = (event, metadata = {}, childId = null) => {
  try {
    API.post('/activity', { event, metadata, ...(childId ? { childId } : {}) }).catch(() => {});
  } catch {
    /* never break the UI for analytics */
  }
};

export default recordActivity;
